export const ruContent = {
  code: 'RU',
  locale: 'ru-RU',
  nav: {
    about: 'О нас',
    atms: 'Банкоматы',
    services: 'Услуги',
    partner: 'Стать партнером',
    search: 'Поиск',
  },
  common: {
    home: 'Главная',
    learnMore: 'Подробнее',
    viewServices: 'Посмотреть услуги',
    back: 'Назад',
    regulated: 'ЗАО «Финбокс» находится под надзором Центрального банка Республики Армения.',
    address: 'г. Ереван, ул. Маро Маргарян, 2/4',
    contact: 'Связаться с нами',
    general: 'Общее',
    information: 'Информация',
    country: 'Армения',
    copyrightName: 'ЗАО «Финбокс»',
  },
  home: {
    eyebrow: 'НЕЗАВИСИМАЯ СЕТЬ БАНКОМАТОВ',
    title: 'Первая и единственная независимая сеть банкоматов в Армении.',
    lead: 'Finbox меняет платежно-расчетный рынок Армении, делая снятие наличных проще и удобнее.',
    visionTitle: 'Наше видение',
    vision: 'Обеспечить рынок Армении инновационными финансовыми продуктами и современной сетью центров самообслуживания, экономя время клиентов при совершении наличных и безналичных операций.',
    valuesTitle: 'Наши ценности',
    values: [
      ['Честность и прозрачность', 'Мы обслуживаем все финансовые организации на равных условиях, создавая атмосферу доверия и безопасности.'],
      ['Развитие', 'Мы внедряем новейшие финансовые технологии и адаптируем лучшие мировые практики.'],
      ['Люди', 'Наши главные ценности — клиенты, профессиональная команда и надежные партнеры.'],
    ],
    servicesTitle: 'Финансовые услуги в единой сети',
    servicesLead: 'От снятия наличных до оплаты более 400 услуг.',
    services: [
      ['Банкоматы', 'Активируйте карту, меняйте PIN-код, проверяйте баланс, снимайте наличные и совершайте переводы.', 'landmark'],
      ['Терминалы', 'Платежи, переводы и технические решения для вашего бизнеса.', 'panels-top-left'],
      ['Более 400 услуг', 'Коммунальные, государственные, банковские, кредитные, страховые и другие платежи.', 'badge-check'],
    ],
    ctaTitle: 'Станьте партнером FINBOX',
    ctaText: 'Присоединяйтесь к независимой финансовой сети и развивайте доступные услуги по всей Армении.',
  },
  about: {
    title: 'О нас',
    intro: 'ЗАО «Финбокс» объединяет традиционные платежно-расчетные инструменты и инновационные финтех-решения, предлагая качественные современные услуги.',
    missionTitle: 'Наша миссия',
    mission: 'Повышать операционную эффективность и надежность путем внедрения передовых технологий финансовых центров самообслуживания.',
    goalTitle: 'Наша цель',
    goal: 'Стать национальным лидером в сфере платежно-расчетных операций. Развивая сеть финансовых центров самообслуживания по всей Армении, мы стремимся обеспечить доступность финансовых услуг для каждого.',
  },
  atms: {
    title: 'С помощью банкомата Finbox вы можете:',
    intro: 'Безопасные и доступные операции самообслуживания за несколько простых шагов.',
    items: [
      ['Активировать карту', 'Вставьте карту, выберите «Активация карты», введите код, отправленный на зарегистрированный в банке номер телефона, и установите удобный PIN-код.'],
      ['Изменить PIN-код карты', 'Вставьте карту, выберите «Дополнительные услуги», затем «Изменение PIN-кода». Введите действующий PIN-код и установите новый.'],
      ['Снять наличные и проверить баланс', 'В банкомате можно проверить баланс карты и снять наличные, введя сумму вручную или выбрав один из предложенных вариантов.'],
      ['Выполнить перевод с карты на карту', 'Выберите «Перевод с карты на карту», введите номер карты получателя и сумму перевода. Перевод выполняется за считанные секунды.'],
      ['Получить выписку по последним 7 поступлениям на пенсионный счет', 'В разделе «Дополнительные услуги» выберите «Выписка по пенсионному счету». Банкомат распечатает выписку в виде чека.'],
      ['Получить выписку по последним 12 нерассчитанным операциям', 'В разделе «Дополнительные услуги» выберите «Нерассчитанные операции» и получите выписку по операциям, средства за которые еще не списаны.'],
    ],
  },
  faq: {
    title: 'Часто задаваемые вопросы',
    intro: 'Краткие ответы на вопросы о банкоматах и терминалах FINBOX.',
    items: [
      ['Где находятся банкоматы и терминалы Finbox?', 'Банкоматы и терминалы Finbox установлены в удобных местах Еревана и регионов Армении: в торговых сетях, на рынках, в торговых центрах, магазинах, офисах банков и крупных компаний, а также в зонах отдыха.'],
      ['Какие услуги можно оплатить через терминалы Finbox?', 'Через терминалы Finbox можно оплатить более 400 услуг. Полный перечень доступен на странице «Услуги».'],
      ['Какие денежные средства принимают терминалы Finbox?', 'Можно совершить платеж на сумму до 50 000 драмов всеми номиналами банкнот, а также монетами номиналом 100, 200 и 500 драмов.'],
    ],
  },
  partner: {
    title: 'Стать партнером',
    intro: 'Заполните необходимые поля, и наша команда свяжется с вами для обсуждения сотрудничества.',
    firstName: 'Имя',
    lastName: 'Фамилия',
    email: 'Электронная почта',
    phone: 'Номер телефона',
    message: 'Сообщение',
    send: 'Отправить',
    required: 'Заполните обязательное поле.',
    invalidEmail: 'Введите корректный адрес электронной почты.',
    ready: 'Форма готова к отправке через вашу почтовую программу.',
  },
  mediator: {
    title: 'Примиритель финансовой системы',
    addressLabel: 'Адрес',
    address: 'Республика Армения, 0010, г. Ереван, ул. М. Хоренаци, 15, бизнес-центр «Элит Плаза», 7-й этаж',
    phone: 'Телефон: (+374 60) 70-11-11',
    fax: 'Факс: (+374 10) 58-24-21',
    hoursTitle: 'Часы работы',
    hours: 'Понедельник–пятница: 9:00–18:00, перерыв: 13:00–14:00. Группа приема жалоб и требований работает также во время перерыва.',
    website: 'Веб-сайт',
  },
  services: {
    title: 'Виды платежей',
    intro: 'Платежные услуги, доступные круглосуточно.',
    bankTitle: 'Банки - Тарифы',
    bankDescription: '17 банков',
    cardRefillTitle: 'Платежи Visa / Mastercard',
    cardRefillIntro: 'Тарифы на пополнение карты по обслуживающим банкам.',
    accountRefillTitle: 'Пополнение счета',
    accountRefillIntro: 'Тарифы на пополнение банковского счета по обслуживающим банкам.',
    chooseTariff: 'Посмотреть тарифы',
    bank: 'Банк',
    bankListIntro: 'Выберите нужный банк.',
    more: 'Подробнее',
    code: 'Код',
    detailIntro: 'Виды платежей, комиссии и лимиты операций.',
    paymentTypes: ['Пополнение банковского счета', 'Пополнение карты', 'Погашение кредита', 'Пополнение счета', 'Пополнение карты'],
    feeModel: 'Тариф комиссии',
    feeTiers: ['1 000–20 000 драмов — 200 драмов', '20 001–50 000 драмов — 300 драмов', '50 001–100 000 драмов — 400 драмов', '100 001–400 000 драмов — 0,5%'],
    minimumFee: 'Минимальная комиссия',
    maximumTransaction: 'Максимальная сумма операции',
    paymentType: 'Вид платежа',
    commission: 'Комиссия',
    limit: 'Лимит',
    standardFee: 'Стандартный тариф A',
    amd: 'драмов',
  },
  reports: {
    title: 'Отчеты',
    intro: 'Годовая финансовая отчетность',
    pending: 'PDF-файл еще не добавлен',
    download: 'Скачать PDF',
    items: [
      { year: 2025, fileName: 'FINBOX_2025_Arm.pdf', size: '4.3 MB', url: '/assets/reports/FINBOX_2025_Arm.pdf' },
      { year: 2024, fileName: 'FINBOX_2024_Arm.pdf', size: '14.7 MB', url: '/assets/reports/FINBOX_2024_Arm.pdf' },
    ],
  },
  consumerRights: {
    title: 'Права потребителей',
    intro: 'Информация о жалобах, заявлениях и защите прав потребителей.',
    documentsTitle: 'Регламентирующие документы',
    documentsIntro: 'Утвержденные документы FINBOX будут размещены здесь.',
    documents: ['Порядок рассмотрения жалоб и заявлений', 'Порядок подачи жалоб и заявлений'],
    pending: 'Документ будет добавлен',
    paragraphs: [
      'Жалобы и заявления, направленные в ЗАО «Финбокс», рассматриваются, а ответы предоставляются в соответствии с утвержденными внутренними правилами компании.',
      'С условиями предоставления услуг и приема платежей ЗАО «Финбокс» можно ознакомиться в разделе',
    ],
    acceptedTitle: 'Жалобы и заявления принимаются:',
    responseNote: 'Сроки и порядок предоставления ответа будут опубликованы вместе с соответствующими регламентирующими документами.',
  },
  usefulLinks: {
    title: 'Полезные ссылки',
    intro: 'Официальные и информационные ресурсы финансовой системы.',
    items: [
      ['Центральный банк', 'Официальный сайт Центрального банка Республики Армения', 'https://www.cba.am/'],
      ['Примиритель финансовой системы', 'Служба урегулирования финансовых споров и защиты прав потребителей', 'https://fsm.am/'],
      ['Фининфо', 'Платформа для сравнения финансовых услуг и получения информации о них', 'https://www.fininfo.am/'],
      ['ABC Finance', 'Платформа финансового образования ABC Finance', 'https://abcfinance.am/'],
      ['ArCa', 'Онлайн-сервисы платежной системы Armenian Card', 'https://cabinet.arca.am/'],
    ],
    disclaimer: 'ЗАО «Финбокс» не несет ответственности за достоверность содержимого внешних ресурсов, ссылки на которые размещены на этом сайте, и возможные последствия его использования.',
  },
  cookiePolicy: {
    title: 'Политика использования файлов cookie',
    intro: 'Информация о возможном использовании файлов cookie и аналогичных технологий на сайте.',
    contentsTitle: 'Содержание',
    opening: [
      'ЗАО «Финбокс» может использовать на своем официальном сайте atm.finbox.am и в связанных цифровых сервисах файлы cookie и аналогичные технологии регистрации информационного потока для обеспечения работы сайта, персонализации и повышения качества обслуживания.',
      'Компания вправе вносить изменения в настоящую политику. Последняя редакция публикуется на сайте и вступает в силу с момента публикации. Пользователям рекомендуется периодически знакомиться с актуальной редакцией политики.',
    ],
    sections: [
      {
        title: 'Назначение файлов cookie',
        paragraphs: [
          'Cookie — это небольшой файл данных, который сайт сохраняет на устройстве пользователя. Он может содержать уникальный идентификатор и передаваться сайту при последующих посещениях.',
          'Файлы cookie могут хранить состояние посещения, предпочтения, сведения об использованных функциях и техническую информацию о просмотренных страницах.',
        ],
      },
      {
        title: 'Управление файлами cookie',
        paragraphs: [
          'Большинство браузеров принимает файлы cookie автоматически. Пользователь может удалить или заблокировать их в настройках браузера.',
          'Ограничение использования файлов cookie может повлиять на доступность или работу отдельных функций сайта.',
        ],
      },
      {
        title: 'Рекламные и аналитические файлы cookie',
        paragraphs: [
          'Рекламные файлы cookie, если они используются, помогают показывать пользователю более релевантные материалы и оценивать частоту просмотра рекламы.',
          'Аналитические файлы cookie предоставляют сведения о маршрутах посещения сайта, взаимодействии со страницами и наиболее востребованных функциях, помогая улучшать сайт.',
        ],
      },
      {
        title: 'Файлы cookie для персонализации и безопасности',
        paragraphs: [
          'Файлы cookie для персонализации могут распознавать повторные посещения и сохранять настройки и предпочтения пользователя.',
          'Файлы cookie безопасности используются для выявления рисков, идентификации пользователей и защиты данных от несанкционированного доступа.',
        ],
      },
      {
        title: 'Файлы cookie для управления сайтом',
        paragraphs: [
          'Файлы cookie для управления сайтом могут сохранять состояние входа, ход посещения и технические данные, введенные на страницах, чтобы работа не прерывалась неожиданно.',
          'Обычно эти файлы cookie управляются как единая функциональная группа и могут быть необходимы для основной работы сайта.',
        ],
      },
    ],
  },
  search: {
    title: 'Поиск',
    intro: 'Поиск по страницам и услугам сайта.',
    placeholder: 'Введите поисковый запрос',
    empty: 'Начните вводить запрос, чтобы увидеть результаты.',
    noResults: 'Ничего не найдено.',
  },
  offer: {
    title: 'Публичная оферта',
    item: 'Публичная оферта 2024',
    open: 'Открыть оригинал',
  },
  atmMap: {
    title: 'Найдите ближайший банкомат FINBOX',
    intro: 'Выберите адрес, чтобы посмотреть его на карте.',
    count: ' адреса',
    route: 'Построить маршрут',
    locations: [{ name: 'Воскеваз', address: 'ул. Араратян, 17' }, { name: 'Ереван', address: 'ул. Мовсеса Хоренаци, 35' }],
  },
  ui: {
    mainNavigation: 'Основная навигация',
    menu: 'Меню',
    pageNotFound: 'Страница не найдена',
    atmLabel: 'Банкомат FINBOX',
    atmServiceImageAlt: 'Услуги банкоматов FINBOX',
    partnershipImageAlt: 'Партнерство с FINBOX',
    partnerEmailSubject: 'Заявка на партнерство с FINBOX',
    formName: 'Имя',
    formEmail: 'Электронная почта',
    formPhone: 'Телефон',
  },
};
